export default {
  state: {
    reloadTimes: 0,
    dailyCloseTimer: null
  },
  actions: {
    allReload ({ commit }) {
      commit('timesPlus')
    },
    SetDailyCloseTimer ({ commit }, value) {
      commit('dailyCloseTimer', value)
    }
  },
  mutations: {
    timesPlus (state) {
      state.reloadTimes += 1
    },
    dailyCloseTimer (state, value) {
      state.dailyCloseTimer = value
    }
  },
  getters: {
    loadTimes: state => state.reloadTimes,
    GetDailyCloseTimer: state => state.dailyCloseTimer
  }
}